import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { ModalPriorityService } from './modal-priority.service';

@Injectable({
  providedIn: 'root'
})
export class SessionRevokedService {
  private router = inject(Router);
  private authService = inject(AuthService);
  private modalPriorityService = inject(ModalPriorityService);
  private showModalSubject = new BehaviorSubject<boolean>(false);
  public showModal$: Observable<boolean> = this.showModalSubject.asObservable();

  showSessionRevokedModal(): void {
    // Clear auth storage when session is revoked
    // Don't use logout() as it navigates immediately - we want to show modal first
    // Priority is set by interceptor
    this.authService.clearAuthStorage();
    this.showModalSubject.next(true);
  }

  closeModal(): void {
    this.showModalSubject.next(false);
    // Clear priority if this was the active modal
    if (this.modalPriorityService.getCurrentPriority() === 'session-revoked') {
      this.modalPriorityService.clear();
    }
  }

  navigateToLogin(): void {
    this.closeModal();
    this.router.navigate(['/signin']);
  }
}
